import Link from 'next/link'
import React from 'react'

import { buildActionAnalyticsAttributes } from '@mondough/analytics-v2'
import { useCopy } from '@mondough/copy'

import appStore from '../../public/images/download-app-store.svg'
import googlePlay from '../../public/images/download-google-play.svg'
import { getCDNSrc } from '../../utils'
import { AppStoreButtonProps } from './AppStoreButton.props'

const AppStoreButton = ({ href, store }: AppStoreButtonProps) => {
  const c = useCopy()
  return (
    <Link
      href={href}
      target="_blank"
      {...buildActionAnalyticsAttributes(`footer-${store}-tap`)}
    >
      <img
        src={getCDNSrc(store === 'app-store' ? appStore : googlePlay)}
        alt={
          store === 'app-store'
            ? c.string({
                key: 'app_tabs_monzo_me.app_store_button.ios.alt',
                message: 'Download on the Apple App Store',
              })
            : c.string({
                key: 'app_tabs_monzo_me.app_store_button.android.alt',
                message: 'Get it on Google Play',
              })
        }
        height={40}
      />
    </Link>
  )
}

export default AppStoreButton
